import { render, staticRenderFns } from "./MportsFormHeader.vue?vue&type=template&id=5a0b1056"
import script from "./MportsFormHeader.vue?vue&type=script&lang=js"
export * from "./MportsFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports